import { proxy } from 'valtio';

type SessionId = string | undefined;

const defaultSessionId = { sessionId: undefined };

export const currentSessionId: { sessionId: SessionId } = proxy(defaultSessionId);
